import type { LayoutMenuGroup } from '@src/services/layout-menu.service'

export const Environment = {
  API_PATH: 'api/public',
  TITLE: 'Espace Adhérent',
  LOGO: 'assets/logo-menu-adherent.svg',
  LAYOUT_MENU: <Array<LayoutMenuGroup>>[
    {
      separator: true,
    },
    {
      // Titre large car le filtrage est par entrée : un organisme de formation
      // sans activité employeur ne garde ici que "Tester l'éligibilité".
      label: 'Financements - outils',
      items: [
        {
          label: 'Consulter les demandes de ma structure',
          icon: 'pi pi-folder text-white',
          routerLink: 'demandes',
          audience: 'EMPLOYER_HISTORY',
        },
        {
          // Sans audience, à dessein : tout le monde la garde.
          label: "Tester l'éligibilité",
          icon: 'pi pi-external-link text-white',
          url: 'https://forms.cloud.microsoft/e/wL8V4PYwtv',
        },
        {
          label: 'Faire une demande : Fonds compétences',
          icon: 'pi pi-plus text-white',
          routerLink: '/financement',
          audience: 'EMPLOYER',
        },
        {
          label: 'Faire une demande : Parcours diplômant',
          icon: 'pi pi-external-link text-white',
          url: 'https://forms.cloud.microsoft/e/g6gpqddg1u',
          audience: 'EMPLOYER',
        },
        {
          label: 'Faire une demande : Relance / impulsion',
          icon: 'pi pi-external-link text-white',
          url: 'https://forms.cloud.microsoft/e/Rhh3Lx075p',
          audience: 'EMPLOYER',
        },
      ],
    },
    {
      label: 'Structure(s) rattachée(s)',
      items: [
        { label: 'Consulter les structures', icon: 'pi pi-building text-white', routerLink: 'structures' },
        { label: 'Ajouter une structure', icon: 'pi pi-plus text-white', routerLink: '/structure' },
        { label: 'Demande de rattachement', icon: 'pi pi-check text-white', routerLink: 'demande-de-rattachement' },
      ],
    },
    {
      label: '<span class="rsi-theme-of rsi-role-label">Organismes de formation</span>',
      escape: false,
      audience: 'TRAINING_ORGANIZATION',
      items: [
        {
          label: 'Consulter les demandes de mes structures clientes',
          icon: 'pi pi-book text-white',
          routerLink: 'formations',
          // `rsi-theme-of` redefinit --rsi-primary, dont depend le fond au
          // survol : l'entree OF s'allume en orange et non en turquoise.
          styleClass: 'rsi-theme-of',
        },
      ],
    },
    {
      label: 'Versements',
      audience: 'EMPLOYER_HISTORY',
      items: [
        {
          label: 'Saisir un versement',
          icon: 'pi pi-calendar text-white',
          url: 'https://forms.cloud.microsoft/e/5rGS06nG7F',
          audience: 'EMPLOYER',
        },
        { label: 'Consulter les versements', icon: 'pi pi-file text-white', routerLink: 'versements' },
        { label: 'Consulter les versements projet', icon: 'pi pi-file text-white', routerLink: 'versements-projets' },
        {
          label: 'Tuto versement',
          icon: 'pi pi-external-link text-white',
          url: 'https://www.fiaf.nc/boite-a-outils/bordereaux-de-versement',
        },
      ],
    },
    {
      label: 'Programmation du FIAF',
      audience: 'EMPLOYER_HISTORY',
      items: [
        {
          label: 'Consulter les formations',
          icon: 'pi pi-book text-white',
          url: 'https://www.fiaf.nc/employeurs/programmation-du-fiaf',
        },
      ],
    },
    {
      label: 'Jeux du FIAF',
      items: [
        {
          label: 'Employeurs - Eléments',
          icon: 'pi pi-calendar text-white',
          url: 'https://element.fiaf.nc',
        },
        {
          label: 'Organismes de formation - Origines',
          icon: 'pi pi-calendar text-white',
          url: 'https://origines.fiaf.nc',
        },
      ],
    },
  ],
}
